import { createSlice } from '@reduxjs/toolkit'

export const lgSlice = createSlice({
  name: 'lg',
  initialState: {
    value: 1,
  },
  reducers: {
    set_la: (state) => {
      // ພາສາລາວ
      console.log('set_la')
      state.value = 1
    },
    set_ch: (state) => {
      // ພາສາຈີນ
      console.log('set_ch')
      state.value = 2
    },

  },
})
export const { set_la, set_ch } = lgSlice.actions

export default lgSlice.reducer